import { createContext, useContext } from 'react'

import type { InputSize, SelectOption } from './types'

export type SelectStateContextValue = {
  size: InputSize
  error: boolean
  disabled: boolean
  readonly: boolean
  ariaLabel?: string
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  maxTagsDisplayed?: number
  placeholder: string
  mode: 'single' | 'multiple' | 'group'
  value?: string | string[]
  onChange?: (value: string | string[]) => void
  options: SelectOption[]
  flattenedOptions: SelectOption[]
}

export const SelectStateContext = createContext<SelectStateContextValue | undefined>(undefined)

export const useSelectStateContext = () => {
  const context = useContext(SelectStateContext)
  if (!context)
    throw new Error('useSelectStateContext must be used within a SelectStateContext.Provider')
  return context
}
